import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import { updateSection } from "../../../assignmentSlice";

import { getContentHeight } from "../../../../../utils/textUtils";
import {
  parseScrambleQuestion,
  parseSummaryBlankQuestion,
} from "../../../../../utils/parseUtils";

import ArrowButton from "../../widgets/ArrowButton";
import OXPage from "./OX/OXPage";
import TranslationPage from "./translation/TranslationPage";
import ScramblePage from "./scramble/ScramblePage";
import VocabularyPage from "./vocabulary/VocabularyPage";
import UnderstandingTestPage from "./understanding/UnderstandingTestPage";
import SummaryBlankPage from "./summary/SummaryBlankPage";
import ParagraphModal from "../../common/ParagraphModal";

const DeprecatedComprehensivePage = ({ setCurrentStep, isPreview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);
  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [selectedBlankIndex, setSelectedBlankIndex] = useState(0);
  const [paragraphModelOpen, setParagraphModalOpen] = useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
    data: {},
  };

  useEffect(() => {
    if (!section) return;
    if (section.answer.length > 0) {
      setPageList(section.answer);
      return;
    }
    setPageList(
      section.question.questions.map((question) => {
        if (question.type === "paraphrasing_scramble") {
          return {
            ...question,
            scramble: parseScrambleQuestion(question.scramble),
            input: [],
            isSubmitted: false,
          };
        } else if (question.type === "keyword_meaning") {
          return {
            ...question,
            question: question.question.split(": ")[0],
            isSubmitted: false,
          };
        } else if (question.type === "summary_blank") {
          return {
            ...question,
            question: parseSummaryBlankQuestion(question.question),
            input: [],
            isSubmitted: false,
          };
        }
        return { ...question, isSubmitted: false };
      })
    );
  }, [section]);

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      const nextPage = pageList[currentIndex + 1];
      setCurrentIndex(currentIndex + 1);
      setUserInput(nextPage.input || "");
    } else {
      let isAllAnswered = true;
      let problemIndex = 0;

      pageList.forEach((page, index) => {
        if (!page.isSubmitted) {
          isAllAnswered = false;
          problemIndex = index;
        }
      });

      if (isAllAnswered) {
        if (!isPreview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert(problemIndex + "번째 문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      const prevPage = pageList[currentIndex - 1];
      setCurrentIndex(currentIndex - 1);
      setUserInput(prevPage.input || "");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: getContentHeight(),
        padding: "0 40px",
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* 왼쪽 화살표 */}
      <ArrowButton
        direction="left"
        onClick={handlePreviousPage}
        visibleCondition={currentIndex > 0}
      />

      {currentPage.type && currentPage.type.includes("ox") && (
        <OXPage
          currentPage={currentPage}
          currentIndex={currentIndex}
          pageList={pageList}
          setPageList={setPageList}
        />
      )}
      {currentPage.type && currentPage.type === "translation" && (
        <TranslationPage
          userInput={userInput}
          currentPage={currentPage}
          currentIndex={currentIndex}
          pageList={pageList}
          setPageList={setPageList}
          setUserInput={setUserInput}
        />
      )}
      {currentPage.type && currentPage.type === "paraphrasing_scramble" && (
        <ScramblePage
          currentPage={currentPage}
          currentIndex={currentIndex}
          pageList={pageList}
          setPageList={setPageList}
        />
      )}
      {currentPage.type && currentPage.type === "keyword_meaning" && (
        <VocabularyPage
          userInput={userInput}
          currentPage={currentPage}
          currentIndex={currentIndex}
          pageList={pageList}
          setPageList={setPageList}
          setUserInput={setUserInput}
        />
      )}
      {currentPage.type && currentPage.type === "understanding_test" && (
        <UnderstandingTestPage
          userInput={userInput}
          currentPage={currentPage}
          currentIndex={currentIndex}
          pageList={pageList}
          setPageList={setPageList}
          setUserInput={setUserInput}
        />
      )}
      {currentPage.type && currentPage.type === "summary_blank" && (
        <SummaryBlankPage
          userInput={userInput}
          currentPage={currentPage}
          currentIndex={currentIndex}
          selectedBlankIndex={selectedBlankIndex}
          pageList={pageList}
          setPageList={setPageList}
          setUserInput={setUserInput}
          setSelectedBlankIndex={setSelectedBlankIndex}
        />
      )}

      {/* 오른쪽 화살표 */}
      <ArrowButton
        direction="right"
        onClick={handleNextPage}
        visibleCondition={true}
      />
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          height: "70px",
          width: "100vw",
          backgroundColor: "#F6F8FA", // 바 색상
          color: "#737373",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {currentIndex + 1} / {pageList.length}
      </div>
      <button
        style={{
          position: "fixed",
          top: "85px",
          right: "55px",
          padding: "9.5px 25px",
          fontSize: "18px",
          borderRadius: "5px",
          backgroundColor: "#2D2D2D", // 바 색상
          color: "#FFF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => setParagraphModalOpen(!paragraphModelOpen)}
      >
        본문 보기
      </button>
      {paragraphModelOpen && (
        <ParagraphModal
          paragraph={section?.question.full_text}
          setParagraphModalOpen={setParagraphModalOpen}
        />
      )}
    </div>
  );
};

export default DeprecatedComprehensivePage;
